module.exports = __webpack_public_path__ + "static/media/pcs-enterprise.8a8830c3.png";